import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class NgbModalService {
  constructor() {}
  public rightModal: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    windowClass: 'theme-modal'
  };

  public confirmationModal: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    windowClass: 'theme-modal-confirm',
    centered: true
  };

  public centerModal: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    windowClass: 'theme-modal-centered',
    centered: true
  };

  public previewModal: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    windowClass: 'theme-modal-preview'
  };

  public fullscreenModal: NgbModalOptions = {
    backdrop: 'static',
    windowClass: 'theme-modal-fullscreen',
    keyboard: false,
    centered: true
  };
}
